"use client";

import { Sparkles } from "lucide-react";
import { TrishCTA } from "~/components/siteglue/siteglue-cta";
import { HomeAgentSignature } from "~/components/siteglue/home/home-agent-signature";
import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";
import { TRISH_CARD_COPY } from "~/lib/siteglue/cta-config";
import { SITEGLUE_COLORS } from "~/lib/siteglue/marketing-chrome";

const TRISH_AVATAR = "/marketing/trish-onboarding-agent.png";

export function SiteGlueHomeMeetTrish() {
  return (
    <HomeSection id="meet-trish" tone="slate">
      <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
        <FadeIn>
          <div className="mx-auto w-full max-w-sm lg:mx-0">
            <HomeAgentSignature
              tone="light"
              agentName="Trish"
              agentTitle="SiteGlue Onboarding Specialist"
              companyName="SiteGlue"
              avatarSrc={TRISH_AVATAR}
              accentColor={SITEGLUE_COLORS.green}
              phoneDisplay="(720) 443-2710"
              emailAddress="trish@siteglue.ai"
              websiteDisplay="www.siteglue.ai"
            />
          </div>
        </FadeIn>

        <FadeIn delay={0.1}>
          <HomeEyebrow>Meet Trish</HomeEyebrow>
          <HomeHeading>SiteGlue Onboarding Specialist.</HomeHeading>
          <HomeLead>{TRISH_CARD_COPY.body}</HomeLead>
          <ul className="mt-6 space-y-3 text-sm text-slate-700">
            {[
              "Sets up your AI agent from your website and channels",
              "Guides a step-by-step review before you go live",
              "Keeps Human-in-the-Loop™ handoff in every deployment",
            ].map((item) => (
              <li key={item} className="flex items-start gap-2.5">
                <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-[#9cbb5a]" aria-hidden />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <p className="mt-5 text-sm font-medium text-slate-600">{TRISH_CARD_COPY.supporting}</p>
          <div className="mt-8">
            <TrishCTA location="homepage_trish_section" testId="button-home-meet-trish" />
          </div>
        </FadeIn>
      </div>
    </HomeSection>
  );
}
